export default __webpack_public_path__ + "static/media/ourstaff-icon.da368e8f.svg";